// src/components/ZakatCalculatorCard/ZakatCalculatorCard.tsx
import React from 'react';
import './ZakatCalculatorCard.css';

const ZakatCalculatorCard: React.FC = () => {
  return (
    <section id="zakat-calculator" className="zakat-calculator-section">
      <div className="zakat-calculator-card">
          {/* En-tête avec logo */}
          <div className="zakat-header">
            <div className="zakat-logo-wrapper">
              <img 
                src="/images/logoZakat.png" 
                alt="Calculateur de Zakat" 
                className="zakat-logo"
              />
            </div>
            <div className="zakat-title-wrapper">
              <h2 className="zakat-title">Calculateur de Zakat</h2>
              <p className="zakat-subtitle">Simple, rapide et conforme à la Sounnah</p>
            </div>
          </div>

          {/* Description */}
          <div className="zakat-description">
            <p>
              Un outil complet pour calculer votre Zakat selon les enseignements authentiques,
              avec plus de 100 fatwas du Cheykh Souleymâne ar-Rouheylî.
            </p>
          </div>

          {/* Fonctionnalités */}
          <div className="zakat-features">
            <div className="zakat-feature">
              <div className="feature-icon">⚡</div>
              <div className="feature-content">
                <h3>Calcul Instantané</h3>
                <p>Obtenez le montant de votre Zakat en quelques clics</p>
              </div>
            </div>

            <div className="zakat-feature">
              <div className="feature-icon">📚</div>
              <div className="feature-content">
                <h3>Guide Complet</h3>
                <p>Apprenez les règles de la Zakat facilement</p>
              </div>
            </div>

            <div className="zakat-feature">
              <div className="feature-icon">📖</div>
              <div className="feature-content">
                <h3>100+ Fatwas</h3>
                <p>Réponses détaillées aux questions courantes</p>
              </div>
            </div>

            <div className="zakat-feature">
              <div className="feature-icon">📱</div>
              <div className="feature-content">
                <h3>Multi-Plateforme</h3>
                <p>Utilisable sur smartphone, tablette et ordinateur</p>
              </div>
            </div>
          </div>

          {/* Informations complémentaires */}
          <div className="zakat-info-box">
            <div className="info-item">
              <span className="info-icon">✅</span>
              <span>100% Gratuit</span>
            </div>
            <div className="info-item">
              <span className="info-icon">🔒</span>
              <span>Aucune donnée collectée</span>
            </div>
            <div className="info-item">
              <span className="info-icon">⚡</span>
              <span>Installable (PWA)</span>
            </div>
          </div>

          {/* Crédit */}
          <div className="zakat-credit">
            <p>✒️ Conception & Traduction : Mâhî Bâyân</p>
          </div>

          {/* Bouton d'action */}
          <div className="zakat-action">
            <a 
              href="https://zakat-calculateur.netlify.app/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="zakat-btn"
            >
              <span>Accéder au calculateur</span>
              <svg 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
          </div>
      </div>
    </section>
  );
};

export default ZakatCalculatorCard;
